import type * as React from "react";
import { cx } from "../internal/cx.js";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Visual shape of the placeholder. `rectangle` is the default and
   * matches a content block. `text` is a single-line variant; `circle`
   * is for avatars and icon placeholders.
   */
  shape?: "rectangle" | "circle" | "text";
}

/**
 * Animated placeholder shown while content is loading. Set explicit
 * dimensions via `style`, `width`, or a wrapping container — the
 * skeleton stretches to fill its parent by default.
 */
export function Skeleton({ className, shape = "rectangle", ...props }: SkeletonProps) {
  return (
    <div
      className={cx("cw-v2-skeleton", `cw-v2-skeleton--${shape}`, className)}
      aria-hidden="true"
      {...props}
    />
  );
}
